export function UpdatePlaceHolderData(data) {
    return {
        type: 'UPDATE_PLACEHOLDER_DATA',
        data
    }
}